import React, { useEffect, useState } from "react";
import { Check, Crown, Lock, Sparkles } from "lucide-react";
import { practiceApi } from "../lib/practiceApi";

export function PlanBanner({ plan, onError }) {
  const [busy, setBusy] = useState(false);
  if (!plan) return null;
  if (plan.plan === "pro") return <div className="plan-banner pro" data-testid="plan-banner-pro">
    <Crown size={16} /><div><strong>ingego Pro attivo</strong>
      <small>Personalizzazione documenti sbloccata: palette, logo e filigrana dello studio.</small></div>
  </div>;
  if (plan.plan === "trial") return <div className="plan-banner pro" data-testid="plan-banner-trial">
    <Sparkles size={16} /><div><strong>Prova di ingego Pro · {plan.trial_days_left} giorni rimasti</strong>
      <small>Personalizza colori, logo e filigrana. Alla fine della prova i documenti tornano al look Standard di ingego,
        senza addebiti. Puoi sbloccare Pro quando vuoi con un pagamento unico di {plan.price.amount.toFixed(0)} €.</small></div>
  </div>;

  async function unlock() {
    setBusy(true); onError?.("");
    try {
      const result = await practiceApi("/payments/checkout", { method: "POST", body: JSON.stringify({ origin_url: window.location.origin }) });
      window.location.href = result.checkout_url;
    } catch (err) { onError?.(err.message); setBusy(false); }
  }

  return <div className="plan-banner" data-testid="plan-banner-standard">
    <div className="plan-banner-head">
      <Sparkles size={16} />
      <div><strong>Piano Standard</strong>
        <small>I documenti usano il look Blu ingego, la filigrana ingego e la riga ingego a piè di pagina.</small></div>
    </div>
    <ul className="plan-features">
      {plan.pro_features.map(feature => <li key={feature}><Check size={13} />{feature}</li>)}
    </ul>
    <button type="button" className="primary" disabled={busy} data-testid="plan-unlock-button" onClick={unlock}>
      <Lock size={15} />{busy ? "Apertura pagamento…" : `Sblocca ingego Pro — ${plan.price.amount.toFixed(0)} € una volta`}
    </button>
    <small>Pagamento unico, nessun abbonamento. L'IVA, se dovuta nel tuo paese, viene calcolata da Stripe al momento del pagamento.</small>
  </div>;
}

export function usePlan(onError) {
  const [plan, setPlan] = useState(null);
  useEffect(() => {
    practiceApi("/plan").then(setPlan).catch(err => onError?.(err.message));
  }, [onError]);
  return plan;
}
